














































































import { Component, Watch } from 'vue-property-decorator';
import MixinDialog from '@/plugins/podolib/services/helper/mixins/dialog';
import { getConfigLink } from '@/lib/build';
import { Severity } from '@sentry/types';

enum Steps {
  Auth = 'authentication',
  Open = 'open',
  Blocked = 'blocked',
  Error = 'error',
}

interface IEquipmentsConfigureKitDialog extends MixinDialog {
  open(): void;
}

@Component<IEquipmentsConfigureKitDialog>({
  created() {
    this.$pdc.bus!.on('equipments:configure-kit-dialog:open', this.open);
  },
  beforeDestroy() {
    this.$pdc.bus!.off('equipments:configure-kit-dialog:open', this.open);
  },
})
export default class EquipmentsConfigureKitDialog extends MixinDialog {
  currentStep: Steps = Steps.Auth;
  isActive: boolean = false;
  timeouts: any = {
    planB: null,
  };
  intervals: any = {
    opener: null,
  };
  pending = false;
  error: Error | null = null;
  win: Window | null = null;
  planB: boolean = false;
  blockedByPrivacy: boolean = false;
  token: string | null = null;

  get Steps() {
    return Steps;
  }

  get link() {
    return `${getConfigLink()}?session=${this.token}`;
  }

  @Watch('error')
  onErrorChanged() {
    this.currentStep = Steps.Error;
    this.clear();
  }

  async open() {
    // Avoid duplication of the process
    if (this.pending) return;
    try {
      // Up pending flag
      this.pending = true;
      // Open dialog
      this.isActive = true;
      // Reset flags / data
      this.error = null;
      this.win = null;
      this.token = null;

      // Try to get configuration token...
      await this.getToken();

      // Launch plan B guard
      this.timeouts.planB = setTimeout(() => {
        this.openPlanB();
      }, 5000);

      // Try to open configurator tab
      await this.openConfiguratorTab();

      // Analytics
      this.$pdc.analytics?.actions.trackSuccess('Kit ConfigStarted');
    } catch (e) {
      // Set 'error' flag
      this.error = e;
      // Sentry
      this.$sentry.captureMessage(e.message, Severity.Error);
    } finally {
      // Reset 'pending' flag
      this.pending = false;
    }
  }

  openPlanB() {
    // Reset timeout
    if (this.timeouts.planB) clearTimeout(this.timeouts.planB);
    this.planB = true;
  }

  close() {
    this.isActive = false;
    this.clear();
  }

  clear() {
    // Reset timeout
    if (this.timeouts.planB) clearTimeout(this.timeouts.planB);
    // Reset intervals
    if (this.intervals.opener) clearInterval(this.intervals.opener);
    // Reset flags / data
    this.error = null;
    this.win = null;
    this.token = null;
    this.planB = false;
  }

  async getToken() {
    // Set step
    this.currentStep = Steps.Auth;
    // Refresh token
    await this.$pdc.cognito!.getUser();
    // Get configuration token...
    const res = await this.$pdc.helper!.getQrcodeAccess();
    // Set token
    this.token = res.data.jwt;
  }

  async openConfiguratorTab() {
    // Set step
    this.currentStep = Steps.Open;
    try {
      // Try to open tab...
      this.win = window.open(this.link, '_blank');
      if (this.win) {
        // Focus the tab
        this.win.focus();

        // Launch plan B guard
        this.intervals.opener = setInterval(() => {
          if (this.win!.closed) {
            clearInterval(this.intervals.opener);

            if (!this.$pdc.entities!.stations.storedEntity.list.length) {
              this.$pdc.bus!.emit('home:welcome-dialog:open');
            }

            this.close();
          }
        }, 100);

        this.win.onerror = () => {
          this.currentStep = Steps.Blocked;
          this.openPlanB();
          if (this.intervals.opener) clearInterval(this.intervals.opener);
        };
      } else {
        this.currentStep = Steps.Blocked;
        this.openPlanB();
      }
    } catch (e) {
      // TODO : add error display
      this.blockedByPrivacy = true;
      // Sentry
      this.$sentry.captureMessage(e.message, Severity.Warning);
    }
  }
}
